import React from "react";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { ConfigProvider, App as AntApp, theme } from "antd";
import { AuthProvider } from "./context/AuthContext";
import RequireAuth from "./components/RequireAuth";
import Login from "./pages/Login";
import AcceptInvite from "./pages/AcceptInvite";
import Layout from "./components/Layout";
import Welcome from "./pages/Welcome";
import DigiTwin from "./pages/DigiTwin";
import BIMFramework from "./pages/BIMFramework";
import Learn from "./pages/Learn";
import Softwares from "./pages/Softwares";
import Team from "./pages/Team";
import Roadmap from "./pages/Roadmap";
import Admin from "./pages/Admin";

export default function App() {
  return (
    <ConfigProvider theme={{ algorithm: theme.darkAlgorithm }}>
      <AntApp>
      <AuthProvider>
        <BrowserRouter>
          <Routes>
            <Route path="/" element={<Login />} />
            <Route path="/accept-invite/:token" element={<AcceptInvite />} />

            {/* PROYAPI is the first tenant; more tenants get their own top-level
                slug the same way once this needs to generalize beyond one. */}
            <Route
              path="/proyapi"
              element={
                <RequireAuth>
                  <Layout />
                </RequireAuth>
              }
            >
              <Route index element={<Welcome />} />
              <Route path="digitwin" element={<DigiTwin />} />
              <Route path="bimframework" element={<BIMFramework />} />
              <Route path="learn" element={<Learn />} />
              <Route path="softwares" element={<Softwares />} />
              <Route path="team" element={<Team />} />
              <Route path="roadmap" element={<Roadmap />} />
              <Route path="admin" element={<Admin />} />
              <Route path="*" element={<Navigate to="/proyapi" replace />} />
            </Route>

            <Route path="*" element={<Navigate to="/" replace />} />
          </Routes>
        </BrowserRouter>
      </AuthProvider>
      </AntApp>
    </ConfigProvider>
  );
}
